import { render, staticRenderFns } from "./TruckInformation.vue?vue&type=template&id=4dbab098&scoped=true&"
import script from "./TruckInformation.vue?vue&type=script&lang=js&"
export * from "./TruckInformation.vue?vue&type=script&lang=js&"
import style0 from "./TruckInformation.vue?vue&type=style&index=0&id=4dbab098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbab098",
  null
  
)

export default component.exports